import { ADD_DYNAMICFIELD_SUCCESS, ADD_DYNAMICFIELD_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const addDynamicFieldReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_DYNAMICFIELD_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case ADD_DYNAMICFIELD_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default addDynamicFieldReducer;
